export default __webpack_public_path__ + "4b3dd049d1598f08b8d28ed0a6ed6326.jpg";